import { lazy } from 'react';

export const ElasticIndexPrefixForm = lazy(
  () => import('./ElasticIndexPrefixForm'),
);
